module.exports = __webpack_public_path__ + "static/media/sortUpActive.8e38bd7b.png";